import React from "react";
import {Link} from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';
import SEO from '../components/SEO';

const DigitalInnovationCurriculum = () => {
  return (
    <>
      <SEO 
        title="Weflare - HTML Coding Course for Kids"
        description="Learn HTML basics with our comprehensive coding course designed for kids in Kenya. Start your digital innovation journey today!"
        keywords="HTML course, coding for kids, digital innovation, programming education, Kenya coding, web development for children"
      />
      <ScrollToTop />
      <div className="container">
        <h1 className="text1 text-center mb-4">HTML Coding Course for Kids</h1>
        
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <p className="lead text-center mb-5">
              Discover the exciting world of web development with our comprehensive HTML course designed specifically for young learners in Kenya.
            </p>
            
            <div className="card-modern p-4 mb-4">
              <h2 className="text1 mb-3">What is Contained in This HTML Course</h2>
              
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body">
                      <h5 className="card-title text-primary">HTML Basics</h5>
                      <ul className="list-unstyled">
                        <li className="mb-2"><i className="bi bi-check-circle text-success me-2"></i>What is HTML?</li>
                        <li className="mb-2"><i className="bi bi-check-circle text-success me-2"></i>How to write, open, and edit HTML</li>
                        <li className="mb-2"><i className="bi bi-check-circle text-success me-2"></i>HTML Elements</li>
                        <li className="mb-2"><i className="bi bi-check-circle text-success me-2"></i>Types of HTML Elements</li>
                      </ul>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6 mb-4">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body">
                      <h5 className="card-title text-primary">Advanced Topics</h5>
                      <ul className="list-unstyled">
                        <li className="mb-2"><i className="bi bi-check-circle text-success me-2"></i>HTML Forms and Input</li>
                        <li className="mb-2"><i className="bi bi-check-circle text-success me-2"></i>Links and Navigation</li>
                        <li className="mb-2"><i className="bi bi-check-circle text-success me-2"></i>Images and Media</li>
                        <li className="mb-2"><i className="bi bi-check-circle text-success me-2"></i>Basic Styling</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Video Section */}
            <div className="text-center mb-5">
              <h2 className="text1 mb-4">Course Preview Video</h2>
              <div className="ratio ratio-16x9 shadow rounded">
                <iframe
                  src="https://www.youtube.com/embed/SiCTXSwqzkw?si=yQjXTdY3IqY_G7bs"
                  title="HTML Course Preview"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="rounded"
                ></iframe>
              </div>
            </div>

            {/* Registration Section */}
            <div className="text-center mb-5">
              <div className="card-modern p-4">
                <h3 className="text1 mb-3">Ready to Start Learning?</h3>
                <p className="lead mb-4">
                  Join our HTML course and begin your journey into web development. Perfect for kids aged 8-16!
                </p>
                <Link to="/programs/learn-coding/questionnaire" className='btn-modern btn-primary text-decoration-none'>
                  <i className="bi bi-person-plus me-2"></i>
                  Register Here
                </Link>
              </div>
            </div>

            {/* Footer Note */}
            <div className="text-center">
              <p className="lead text-muted fst-italic">
                This course is designed to educate kids in Kenya about HTML and digital innovation, 
                fostering the next generation of web developers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DigitalInnovationCurriculum;
